<template>
    <section>
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-md-6">
                            <h2>
                               Email Records
                            </h2>
                        </div>
                    </div>
                    <div v-if="total > 0">
                        <strong>Showing</strong>
                        <span>{{ from }}</span>-<span>{{ to }}</span> of <span>{{ total }}</span>
                        results
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <b-table
                                    class="list-table"
                                    :sort-by.sync="sort_by"
                                    :sort-desc.sync="sort_desc"
                                    :fields="fields"
                                    :items="records"
                                    show-empty
                            >
                                <template v-slot:empty="scope">
                                    No data is available...
                                </template>
                                <template v-slot:cell(action)="data">
                                    <div>
                                        <button
                                                class="btn btn-primary btn-email"
                                                v-if="data.item.email_content"
                                                @click="openEmailPreview(data.item.email_content)"
                                        >View Email</button>
                                    </div>
                                </template>
                            </b-table>

                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">&nbsp;</div>
                    </div>
                    <b-pagination
                        v-if="total > 0"
                        :total-rows="total"
                        v-model="current_page"
                        :per-page="per_page"
                    ></b-pagination>
                </div>
            </div>
        </div>
        <email-preview-modal
            v-model="showEmailPreviewModal"
            :email-html="emailHtml"
            @close="closeEmailPreview">
        </email-preview-modal>
    </section>
</template>
<script>

    import { mapState, mapActions } from 'vuex'
    import EmailPreviewModal from './EmailPreviewModal.vue';
    export default {
        components: {EmailPreviewModal},
      created(){
        this.$store.dispatch('emailRecord/getEmailRecords');
      },
        data() {
            return {
                showEmailPreviewModal: false,
                emailHtml: null,
                sort_by: 'created_at',
                sort_desc: true,
                selected_search: null,
                fields: [
                    {label: 'ID', key: 'id',},
                    {label: 'Created', key: 'formatted_created_at'},
                    {label: 'Subject', key: 'subject',},
                    {label: 'From', key: 'from',},
                    {label: 'To', key: 'to',},
                    {label: 'Action', key: 'action',},
                ],
            }
        },
        computed: {
            ...mapState({
                records: state => state.emailRecord.all,
                per_page: state => state.emailRecord.per_page,
                from: state => state.emailRecord.from,
                to: state => state.emailRecord.to,
                last_page: state => state.emailRecord.last_page,
                total: state => state.emailRecord.total,
            }),
            current_page: {
                get(){
                    return this.$store.getters['emailRecord/getEmailRecords'];
                },
                set(value){
                    if (value) {
                        return this.$store.dispatch('emailRecord/getEmailRecords', {page: value});
                    }
                }
            }
        },
        methods: {
            openEmailPreview(emailHtml) {
                if (emailHtml) {
                    this.emailHtml = emailHtml;
                    this.showEmailPreviewModal = true;
                }
            },
            closeEmailPreview() {
                this.emailHtml = null;
                this.showEmailPreviewModal = false;
            }
        }
    }

</script>
<style scoped>
    .btn-email {
        width: 130px !important;
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/EmailRecord/ListPage.vue